export default __webpack_public_path__ + "img/6b6842a6190c652fb4699782744acd64.svg";